{
  "tabs": {
    "chat": "Söhbet",
    "reminders": "Hatyralar",
    "calendar": "Taqvim",
    "settings": "Sazlamalar"
  },
  "common": {
    "cancel": "Bes et",
    "save": "Ýatda sakla",
    "confirm": "Tassykla",
    "delete": "Öçür",
    "back": "Yza",
    "close": "Ýap",
    "edit": "Üýtget",
    "search": "Gözleg",
    "all": "Ählisi",
    "loading": "Ýüklenýär...",
    "error": "Näsazlyk boldy",
    "notFound": "Tapylmady",
    "tryAgain": "Täzeden synanyşyň",
    "retry": "Täzeden synanyş",
    "undo": "Yza al",
    "pullToRefresh": "Täzelä çek",
    "justNow": "häzir"
  },
  "auth": {
    "welcome": "FishMemory-e hoş geldiňiz",
    "tagline": "Siziň WhatsApp hatyralaýjy kömekçiňiz, indi jübüňizde.",
    "subtitle": "Siziň WhatsApp hatyralaýjy kömekçiňiz, indi jübüňizde.",
    "phoneLabel": "Siziň WhatsApp belgiňiz",
    "phoneHint": "WhatsApp arkaly tassyklama kody ibereris",
    "invalidPhone": "Dogry telefon belgisini giriziň",
    "continue": "Dowam et",
    "enterPhone": "WhatsApp belgiňizi giriziň",
    "phonePlaceholder": "Telefon belgisi",
    "sendCode": "Kod iber",
    "verifyTitle": "Belgini tassyklaň",
    "otpSentTo": "6 sanly kod {{phone}} belgiňize WhatsApp arkaly iberildi",
    "enterFullCode": "6 sany sanly kody doly giriziň",
    "invalidOtp": "Nädogry kod. Täzeden synanyşyň.",
    "otpFailed": "Kod ibermek başartmady. Täzeden synanyşyň.",
    "otpResent": "Kod täzeden iberildi",
    "resendIn": "{{seconds}} s-de täzeden iber",
    "resendCode": "Kody täzeden iber",
    "enterOtp": "WhatsApp-a gelen kody giriziň",
    "verify": "Tassykla",
    "resend": "Kody täzeden iber",
    "wrongNumber": "Nädogry belgi?",
    "backToPhone": "Telefon belgiňize gaýt",
    "editPhone": "Telefon belgini üýtget",
    "error": "Näsazlyk",
    "setupTitle": "Geliň, sazlamalary edeliň",
    "setupSubtitle": "Bu sazlamalary islendik wagt Sazlamalarda üýtgedip bilersiňiz",
    "namePlaceholder": "Adyňyz",
    "letsGo": "Sazlamalary tamamla",
    "skipForNow": "Häzir geç"
  },
  "chat": {
    "title": "FishMemory",
    "placeholder": "Hat ýaz...",
    "inputPlaceholder": "Hat ýaz...",
    "typing": "FishMemory ýazýar...",
    "online": "Onlaýn",
    "connecting": "Baglanýar...",
    "reconnecting": "Täzeden baglanýar...",
    "offline": "Oflaýn",
    "empty": "Söhbet başla",
    "emptyHint": "Hatyralary döret, tertibi barla ýa-da kömek sora.",
    "emptyAction": "Mysal hatyrany iber",
    "actions": "Söhbet amallary",
    "keep": "Hatlary sakla",
    "clearTitle": "Söhbeti arassala",
    "clearConfirm": "Bu enjamdaky ähli hatlary öçürmek isleýärsiňizmi? Bu yzyna gaýtmaz.",
    "clear": "Söhbeti arassala",
    "optionSelected": "Saýlandy: {{label}}",
    "sendingSelection": "Iberilýär...",
    "connectionLost": "Täzeden baglanýar..."
  },
  "reminders": {
    "title": "Meniň Hatyralarym",
    "active": "Işjeň",
    "today": "Şu gün",
    "thisWeek": "Şu hepde",
    "history": "Taryhça",
    "items": "elementler",
    "emptyTitle": "Heniz hatyra ýok",
    "emptySubtitle": "Söhbetden döret, şonda bu ýerde görner.",
    "emptyAction": "Söhbeti aç",
    "filterActive": "Işjeň",
    "filterToday": "Şu gün",
    "filterWeek": "Şu hepde",
    "filterHistory": "Taryhça",
    "emptyState": "Heniz hatyralar ýok. Söhbet başla!",
    "swipeDone": "Tamam",
    "swipeSnooze": "Gecikdir",
    "swipeDelete": "Öçür",
    "search": "Hatyralary gözle...",
    "upcoming": "Geljekde",
    "completed": "Tamamlanan",
    "overdue": "Geçen",
    "tomorrow": "Ertesi gün",
    "synced": "{{value}} sinhronizasiýa edildi",
    "swipeHint": "Has köp amal üçin hatyrany sürüň",
    "noResults": "Gözlegiňize laýyk hatyra ýok",
    "noResultsHint": "Başga söz synanyşyň ýa-da gözlegi arassalaň",
    "deleteAllFailed": "Ähli hatyralary öçürmek başartmady"
  },
  "calendar": {
    "title": "Taqvim",
    "today": "Şu gün",
    "tomorrow": "Ertesi gün",
    "completed": "tamam",
    "noEvents": "Hiç zat meýilleşdirilmändir",
    "noEventsSubtitle": "Hatyralary we wakalary görmek üçin senäni saýlaň.",
    "googleEvent": "Google Taqvim",
    "legendActive": "Işjeň",
    "legendRecurring": "Gaýtalanýan",
    "legendDone": "Tamamlanan",
    "legendGoogle": "Google",
    "previousMonth": "Öňki aý",
    "nextMonth": "Indiki aý",
    "previousYear": "Öňki ýyl",
    "nextYear": "Indiki ýyl",
    "goToToday": "Şu güne git",
    "all": "Ählisi",
    "active": "Işjeň",
    "done": "Tamamlanan",
    "paused": "Duruzylan"
  },
  "settings": {
    "title": "Sazlamalar",
    "profile": "Profil",
    "name": "Görkezme ady",
    "enterName": "Adyňyzy giriziň",
    "language": "Dil",
    "uiLanguage": "Programma dili",
    "uiLanguageHelp": "Bu enjamda diňe programma interfeýsini, taqvim belliklerini we ýerleşiş uguryny üýtgedýär.",
    "serverLanguage": "Söhbet dili",
    "serverLanguageHelp": "Hasabyňyz üçin serwer jogaplary we hatyra hatlary üçin ulanylýan dili üýtgedýär.",
    "timezone": "Wagt zonasy",
    "currentTimezone": "Häzirki wagt zonasy",
    "timezoneHelp": "Ähli hatyra wagtlary şu wagt zonasy boýunça görkezilýär.",
    "timezonePlaceholder": "America/New_York",
    "timezoneSave": "Wagt zonasyny ýatda sakla",
    "timezoneSaved": "Wagt zonasy täzelendi",
    "detect": "Aýdyňlaşdyr",
    "detectFailed": "Wagt zonasyny anyklap bolmady",
    "autoDetect": "GPS-den awtomatiki anyklama",
    "notifications": "Bildirişler",
    "notificationsHelp": "Hatyradan soňky hatyralar gaýtalanýan duýduryşlary dolandyrýar. Enjam derejesindäki bildiriş rugsatlary telefon sazlamalarynda dolandyrylýar.",
    "pushEnabled": "Push bildirişler",
    "autoDoneOnFire": "Işledileninde awtomatiki tamamla",
    "autoDoneOnFireDesc": "Öçürilen bolsa, hatyralar tamamlanýança işjeň galýar.",
    "googleCalendar": "Google Taqvim",
    "google": "Google Taqvim",
    "googleConnected": "Baglanyşyk bar",
    "googleDisconnected": "Baglanyşyk ýok",
    "googleConnectedHelp": "Täze hatyralar taqvimiňize awtomatiki sinhronizasiýa edilip bilner.",
    "googleDisconnectedHelp": "Hatyralar we wakalar sazlaşykly bolsun üçin Google Taqvim bilen baglaň.",
    "googleConnectFailed": "Google Taqvim bilen baglanyşmak başartmady",
    "connected": "Baglanyşyk bar",
    "disconnected": "Baglanyşyk ýok",
    "connect": "Bagla",
    "disconnect": "Baglanyşygy aýyr",
    "autoSync": "Täze hatyralary awtomatiki sinhronizasiýa et",
    "autosync": "Täze hatyralary awtomatiki sinhronizasiýa et",
    "subscription": "Abuna",
    "trialUsed": "Synag: {{used}}/{{total}} ulanyldy",
    "trialStatus": "Synag elýeterli",
    "activeStatus": "Işjeň abuna",
    "expiredStatus": "Abuna möhleti gutardy",
    "unsubscribedStatus": "Abuna däl",
    "about": "Hakynda",
    "version": "Wersiýa",
    "logout": "Çyk",
    "logoutTitle": "Çyk",
    "logoutConfirm": "Çykmak isleýändigiňize ynanýarsyzmy?",
    "noName": "Ad goýulmandyr",
    "serverConnection": "Serwer baglanyşygy",
    "serverUrl": "Serwer URL",
    "serverEdit": "Üýtget",
    "saveReconnect": "Ýatda sakla we täzeden baglan",
    "resetDefault": "Öňki ýagdaýyna getir",
    "invalidServerUrlTitle": "Nädogry serwer URL",
    "invalidServerUrlMessage": "Mysal üçin https://example.com ýaly dogry http ýa-da https serwer URL giriziň",
    "uiLanguageChangeFailed": "Programma dilini üýtgetmek başartmady. Täzeden synanyşyň.",
    "serverLanguageChangeFailed": "Söhbet dilini üýtgetmek başartmady. Täzeden synanyşyň.",
    "timezoneChangeFailed": "Wagt zonasyny üýtgetmek başartmady. Täzeden synanyşyň.",
    "autoSyncChangeFailed": "Awtomatiki sinhronizasiýany täzeläp bolmady. Täzeden synanyşyň.",
    "nameChangeFailed": "Görkezme adyny täzeläp bolmady. Täzeden synanyşyň.",
    "trialDays": "Free trial: {{daysLeft}} day(s) left",
    "trialEnds": "Trial ends {{date}}"
  },
  "reminder": {
    "body": "Hatyranyň jikme-jigi",
    "editTime": "Wagty üýtget",
    "rename": "Adyny üýtget",
    "snooze": "Gecikdir",
    "snooze15": "15 minut gecikdir",
    "pause": "Duruz",
    "pauseReminder": "Hatyrany duruz",
    "resume": "Dowam et",
    "resumeReminder": "Hatyrany dowam etdir",
    "skip": "Indiki geç",
    "skipOccurrence": "Bu gezek geç",
    "syncGoogle": "Google bilen sinhronizasiýa et",
    "delete": "Öçür",
    "deleteTitle": "Hatyrany öçür",
    "deleteConfirm": "Bu hatyra hemişelik öçüriler.",
    "deleteRecurringTitle": "Gaýtalanýan hatyrany öçür",
    "deleteRecurringMessage": "Bu gezek geçmekmi ýa-da ähli seriýany öçürmekmi isleýärsiňiz?",
    "deleteThisOccurrence": "Bu gezek geç",
    "deleteEntireSeries": "Ähli seriýany öçür",
    "done": "Tamam",
    "markDone": "Tamamlandygyny bellä",
    "undo": "Gaýtadan dikelt",
    "undoPrompt": "Täze işjeň bolmagyny isleýärsiňizmi? Häzir dikeldiň.",
    "recurring": "Gaýtalanýan",
    "nextRun": "Indiki iş",
    "oneTime": "Bir gezeklik",
    "pending": "Garaşylýar",
    "sent": "Iberildi",
    "paused": "Duruzylan",
    "active": "Işjeň",
    "snoozed": "Gecikdirilen",
    "localTime": "Ýerli wagtyňyzda görkezilýär",
    "recurrence": "Gaýtalanma",
    "created": "Döredildi",
    "tags": "Bellikler",
    "fireCount": "Işledilen gezekler",
    "actions": "Amallar",
    "none": "Hiç biri",
    "snoozeFailed": "Hatyrany gecikdirmek başartmady",
    "pauseFailed": "Hatyrany duruzmak başartmady",
    "resumeFailed": "Hatyrany dowam etdirmek başartmady",
    "skipFailed": "Hatyrany geçmek başartmady",
    "doneFailed": "Hatyrany tamamlandygyny belläp bolmady",
    "undoFailed": "Hatyranyň ýagdaýyny gaýtadan dikeltmek başartmady",
    "deleteFailed": "Hatyrany öçürmek başartmady",
    "rescheduleTitle": "Täzeden meýilleşdirmek?",
    "rescheduleMsg": "Bu hatyra wagtyndan geçdi. Täzeden meýilleşdirmek isleýärsiňizmi?",
    "reschedule15": "15 minutdan",
    "reschedule60": "1 sagatdan",
    "keepOverdue": "Şol ýaly sakla"
  },
  "onboarding": {
    "slide1Title": "FishMemory-e hoş geldiňiz",
    "slide1Sub": "Siziň şahsy hatyralaýjy kömekçiňiz — WhatsApp bilen işlenip, jübüňiz üçin döredildi.",
    "slide2Title": "Tegelek Söhbet Edin",
    "slide2Sub": "Hatyralary pikir edýän ýaly ýaz: \"Ertesi gün sagat 15:00-de ejesi jaň etmegi ýadyma sal\" — galanlaryny biz ederis.",
    "slide3Title": "Hiç zat ýatdan çykmasyn",
    "slide3Sub": "Wagtynda bildiriş alyň, bellikler bilen tertipleşdirin, we möhüm zatlaryň üstünde boluň.",
    "getStarted": "Başla",
    "next": "Indiki",
    "firstReminderTitle": "Ilkinji hatyrany dörediň!",
    "firstReminderHint": "Mysal üçin şunuň ýaly ýazyp görüň:",
    "firstReminderExample": "Ertesi gün sagat 9-da suw içmegi ýadyma sal",
    "gotIt": "Düşündim!",
    "notifRationaleTitle": "Wagtynda gal",
    "notifRationaleBody": "FishMemory size wagtynda ýadyňyza salmak üçin bildirişler gerek. Diňe döredýän hatyralaryňyz üçin duýduryşlar alarsyňyz.",
    "notifRationaleAllow": "Bildirişleri aç",
    "notifRationaleLater": "Soňrak bolsun",
    "swipeHint": "Çalt amallar üçin sag tarapa süriň →",
    "calendarDragHint": "Uzaklaşdyrmak üçin süriň ↕"
  }
}
